var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "edit-item-img-modal",
      attrs: {
        title: "",
        visible: _vm.show,
        "close-on-click-modal": false,
        width: "510px",
        bodyHeight: "300px",
        "append-to-body": "",
        top: "25vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.drawRow.type === "add"
                ? _vm.$t("shop-site::facebook_campaign::add_staff")
                : _vm.$t("shop-site::facebook_campaign::edit_staff")
            ) +
            " "
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "user-body",
          attrs: {
            model: _vm.params,
            "label-width": "150px",
            "label-suffix": "：",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "input-box",
              attrs: {
                label: _vm.$t("shop-site::facebook_campaign::upload_avatar"),
                prop: "img",
              },
            },
            [
              _c("pictureUpload", {
                attrs: { folder: "campaign" },
                model: {
                  value: _vm.params.img,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "img", $$v)
                  },
                  expression: "params.img",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "tip-content" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("shop-site::facebook_campaign::upload_avatar_tip")
                ) +
                " "
            ),
          ]),
          _c(
            "el-form-item",
            {
              staticClass: "input-box",
              attrs: {
                label: _vm.$t("shop-site::facebook_campaign::staff_name"),
                prop: "userId",
                rules: {
                  required: true,
                  message: _vm.$t("shop-site::facebook::placeholder_account"),
                  trigger: "change",
                },
              },
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "input-item",
                  attrs: {
                    filterable: "",
                    loading: _vm.vloading,
                    remote: "",
                    "remote-method": _vm.remoteMethod,
                    placeholder: _vm.$t(
                      "shop-site::facebook_campaign::placeholder_staff_name"
                    ),
                  },
                  model: {
                    value: _vm.params.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "userId", $$v)
                    },
                    expression: "params.userId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.userId,
                    attrs: { label: item.loginName, value: item.userId },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "input-box", attrs: { required: "" } },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("shop-site::facebook_campaign::campaign_name")
                      ) +
                      " "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top-start" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "shop-site::facebook_campaign::tooltip_campaign_name"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                      _c("i", {
                        staticClass:
                          "icon-a-01wenhao iconfont-el question-icon",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._l(_vm.params.campaignSigns, function (sign, index) {
                return [
                  _c(
                    "el-form-item",
                    {
                      key: index,
                      staticClass: "mb-20",
                      attrs: {
                        prop: "campaignSigns." + index,
                        rules: {
                          required: true,
                          message: _vm.$t(
                            "shop-site::facebook::placeholder_accountId"
                          ),
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "input-item",
                        attrs: {
                          placeholder: _vm.$t(
                            "shop-site::facebook_campaign::placeholder_campaign_name"
                          ),
                          maxlength: 20,
                        },
                        model: {
                          value: _vm.params.campaignSigns[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.params.campaignSigns, index, $$v)
                          },
                          expression: "params.campaignSigns[index]",
                        },
                      }),
                      _vm.params.campaignSigns.length > 1
                        ? _c(
                            "span",
                            {
                              staticClass: "add-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.reduceSign(index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-minus" })]
                          )
                        : _vm._e(),
                      index === _vm.params.campaignSigns.length - 1
                        ? _c(
                            "span",
                            {
                              staticClass: "add-btn",
                              on: { click: _vm.addSign },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.onSave },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }